import React, { useContext, useReducer } from 'react'
import AppContext from 'context'
import appReducer from 'context/reducer'

import axios from 'axios'
import qs from 'qs'
import WP_DATA from 'utils/wp_data'

export default ({ children }) => {
  const initialState = useContext(AppContext)
  const [state, dispatch] = useReducer(appReducer, initialState)

  const save = async () => {
    dispatch({ type: 'SET_LOADING', payload: true})
    const params = qs.stringify({
      action: 'sg_client_portal_actions',
      do: 'save_worksheet',
      worksheet_id: WP_DATA.worksheet_id,
      worksheet_data: state.worksheet_data,
      permalink: WP_DATA.permalink,
      display_name: WP_DATA.user.data.display_name,
      title: state.title,
    })
    await axios.post(WP_DATA.admin_ajax_url, params)
    dispatch({ type: 'SET_LOADING', payload: false})
  }

  return (
    <AppContext.Provider value={{state, dispatch, save}}>
      { children }
    </AppContext.Provider>
  )
}